import { render, staticRenderFns } from "./DeleteUserMessage.vue?vue&type=template&id=d91f33ae&"
import script from "./DeleteUserMessage.vue?vue&type=script&lang=js&"
export * from "./DeleteUserMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports